import { render } from "./AIPromptModal.vue?vue&type=template&id=3afed78f&scoped=true"
import script from "./AIPromptModal.vue?vue&type=script&lang=js"
export * from "./AIPromptModal.vue?vue&type=script&lang=js"

import "./AIPromptModal.vue?vue&type=style&index=0&id=3afed78f&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3afed78f"]])

export default __exports__